import { Trans } from '@lingui/react/macro';

import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';

export const AdjustServiceDuringProcessingTaskMessage = ({
  article,
}: {
  article: ArticleWithRelations;
}) => {
  return (
    <BaseMessage
      title={
        <Trans id="article.task.adjust_service_during_processing.title">Review services</Trans>
      }
      message={
        <Trans id="article.task.adjust_service_during_processing.message">
          Please ensure that the item and services match what was originally requested.
        </Trans>
      }
      article={article}
    />
  );
};
